import Vue from 'vue'
import Vuex from 'vuex'

const axios = require('axios').default
import qs from 'qs'

import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

//import helpers from './../helpers.js'
//import _ from 'lodash'

import firebase from './modules/firebase.js'
import users from './modules/users.js'
import timelogs from './modules/timelogs.js'
import projects from './modules/projects.js'
import clients from './modules/clients.js'
import economyposts from './modules/economyposts.js'
import specs from './modules/specs.js'
import comments from './modules/comments.js'
import helpers from '../helpers.js'


//------------------------------------------------------------------------------

const logger = createLogger({
  collapsed: false, // auto-expand logged mutations
  filter (mutation, stateBefore, stateAfter) {
    return mutation.type !== "aBlacklistedMutation"
  },
  transformer (state) {
    // transform the state before logging it.
    // for example return only a specific sub-tree
    return state.subTree
  },
  mutationTransformer (mutation) {
    return mutation.type
  },
  logger: console,
})

//------------------------------------------------------------------------------

const store = new Vuex.Store({
  strict: false, // In strict mode, whenever Vuex state is mutated outside of mutation handlers, an error will be thrown
  //plugins: [ createLogger() ], // console.log out all mutations with metadata
  modules: {
    firebase,
    users,
    timelogs,
    specs,
    economyposts,
    projects,
    clients,
    comments,
  },
  state: {
        
    env: undefined,

    firebase_load_pct: 0,
    firebase_synced_and_ready: false,
    
    show_beta_content: false,
    show_debug_data_boxes: false,

    bgfadeimg_tags: 'milk',
    
    count: 0,    

    small_spinner: false,
    big_spinner: false,


    worktypes: [
      { key:'meeting', title:'Møde/dialog' },
      { key:'specs_offer', title:'Kravspec/tilbud' },
      { key:'project_management', title:'Projektstyring' },
      { key:'client_dialog', title:'Kundedialog', legacy: true },
      { key:'graphic_design', title:'Grafisk design' },
      { key:'development', title:'Udvikling' },
      { key:'motiongraphics', title:'Motion graphics' },
      { key:'content', title:'Content' },
      { key:'testing', title:'Testing' },
      { key:'maintenance', title:'Drift/support' },
      { key:'other', title:'Andet' },
    ],


    timeloggerBasic: {
      active: false,
      timelog: {
        hours: undefined,
        worktype: undefined,
        billable: true,
        note: undefined,
        project_key: undefined,
      },
    },

    specLineRobot: {
      active:false,
    },

    context_bg: {
      bgcolor: undefined,
      bgimg: undefined,
    },

    dinero_fetched: undefined,

  },// state
  getters: {


    base_url(state,getters){
      if( state.env === 'local' ) return 'http://localhost:3000/'
      if( state.env === 'live' ) return 'https://kia.milk-studio.dk/'
    },
    
    api_url(state,getters){
      if( state.env === 'local' ) return getters.base_url + 'api/'
      if( state.env === 'live' ) return getters.base_url + 'api/'
    },

    projectsCount(state,getters){
      var output = 0
      for( var key in state.firebase.projects ) {
        var project = state.firebase.projects[key]
        output++
      }
      return output
    },

    something(state,getters){
      return 123
    },

    somethingElse: (state,getters) => state.count + 1,

    // generic use ones (C in CRUD)
    // does not use firebase_arrays, siince they may not be of use. 
    getAll: (state,getters) => (type) => {
      var output = []
      if( !state.firebase[type] ) return output
      
      //for( let key in state.firebase[type] ) output.push(state.firebase[type][key])
      for( let key in state.firebase[type] ) {
        if( typeof state.firebase[type][key] !== 'object' ) continue
        output.push({  ...state.firebase[type][key], ...{ _key:key, '.key':key, key:key } })
      }

      return output
    },
    
    // does not use firebase_arrays, siince they may not be of use. 
    getOne: (state,getters) => (type,key) => {
      if( !state.firebase[type+'s'] ) return
      return {  ...state.firebase[type+'s'][key], ...{ _key:key, '.key':key, key:key } }      
    },



    // less ambitious approach. uses the computed keyedArray ones which have mutated the data
    getAll2: (state,getters) => (type) => {
      if( !getters.firebase_arrays[type] ) return []
      return getters.firebase_arrays[type]
    },
    
    // less ambitious approach. uses the computed keyedArray ones which have mutated the data
    getOne2: (state,getters) => (type,key) =>  {
      for( let item of getters.getAll(type+'s') ) if( item.key === key || item['.key'] === key ) return item
    },
    
    
    get_dinero_invoices: (state,getters) => (input) =>  {
      
      var output = []

      if( !state.dinero_fetched ) return output
      if( !state.dinero_fetched.invoices ) return output

      if( !input ) input = {}

      for( let invoice of state.dinero_fetched.invoices ) {

        if( input.client_cvr !== undefined && invoice.client_cvr != input.client_cvr ) continue
        if( input.status !== undefined && invoice.status !== input.status ) continue
        if( input.invoice_no !== undefined && invoice.invoice_no !== input.invoice_no ) continue

        output.push(invoice)

      }
      
      return output

    },

    get_dinero_invoices_total: (state,getters) => (input) =>  {
      var invoices = getters.get_dinero_invoices(input)
      var total = 0
      for( let inv of invoices ) total += inv.total_ex_vat_dkk
      return total
    },


    //genericGetWith
    //genericGetFiltered
    //genericGetSorted


  },// getters
  mutations: {

    set_env(state,x){ state.env = x },
    set_firebase_load_pct(state,x){ state.firebase_load_pct = x },
    set_context_bgcolor(state,x){ state.context_bg.bgcolor = x },
    set_context_bgimg(state,x){ state.context_bg.bgimg = x },

    set_dinero_fetched(state,x) { state.dinero_fetched = x },
    
    set_small_spinner(state,x) { state.small_spinner = x },
    set_big_spinner(state,x) { state.big_spinner = x },

    firebase_synced_and_ready(state){
      state.firebase_synced_and_ready = true
    },

    increment (state) {
      state.count++
    },

    
    

    toggle_show_beta_content(state,input){
      if( input == undefined ) input = !state.show_beta_content
      state.show_beta_content = input
    },
    
    toggle_show_debug_data_boxes(state,input){
      if( input == undefined ) input = !state.show_debug_data_boxes
      state.show_debug_data_boxes = input
    },

    transferTimelogsFromProjectToProjevy(state,input)
    {
      console.log(input)
    },

    set__bgfadeimg_tags(state,x){ state.bgfadeimg_tags = x },

    set__timeloggerBasic_active(state,x){ state.timeloggerBasic.active = x },
    
    set__timeloggerBasic_timelog(state,x){ Object.assign(state.timeloggerBasic.timelog, x) },
    
    set__specLineRobot_active(state,x){ state.specLineRobot.active = x },

  
  },// mutations
  actions: {

    load_context_bgimg({ commit }, url){
      var img = new Image()
      img.addEventListener('load', () => { commit('set_context_bgimg',url) })
      img.src = url
    },

    
    dinero_fetch({ commit }, version ){
      return new Promise((resolve, reject) => {
        axios.get( 'https://kia.milk-studio.dk/api/dinero_fetch/'+version )
          .then((response)=>{
            commit('set_dinero_fetched', response.data)
            resolve(response)
          })
          .catch((response)=>{
            reject(response)
          })
      })   
    },


  },// actions
})

//------------------------------------------------------------------------------

// store hot reloading: https://vuex.vuejs.org/guide/hot-reload.html

if (module.hot) {
  module.hot.accept([
    './modules/users',      
    './modules/timelogs',      
    './modules/specs',      
    './modules/economyposts',
    './modules/projects',    
    './modules/clients',    
    './modules/comments',    
  ], () => {
    store.hotUpdate({
      modules: {
        users: require('./modules/users').default,
        timelogs: require('./modules/timelogs').default,
        specs: require('./modules/specs').default,
        economyposts: require('./modules/economyposts').default,
        projects: require('./modules/projects').default,
        clients: require('./modules/clients').default,
        comments: require('./modules/comments').default,
      },
    })
  })
}

//------------------------------------------------------------------------------

export default store


// WEBPACK FOOTER //
// ./src/store/store.js